import { render } from "./tambah.vue?vue&type=template&id=7a1729ca&scoped=true"
import script from "./tambah.vue?vue&type=script&lang=js"
export * from "./tambah.vue?vue&type=script&lang=js"

import "./tambah.vue?vue&type=style&index=0&id=7a1729ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1729ca"]])

export default __exports__